import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-privacy-generico-modal',
    templateUrl: './privacy-generico-modal.component.html',
    styleUrls: ['./privacy-generico-modal.component.scss']
})
export class PrivacyGenericoModalComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PrivacyGenericoModalComponent>) { }

    ngOnInit() {
    }

}
